<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <div class="ivu-mt">
      <l-auth-button type="primary" auth="misc_type_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
      <div class="l-simple-search-container"  style="float: right;">
        <el-input placeholder="请输入查找内容" v-model="search_data.name" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>
      </div>
      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="100"> </el-table-column>
         <el-table-column prop="is_active" label="是否启用" width="130">
        <template slot-scope="{ row }">
           <el-tag :type="row.is_active == 1 ? 'success' : 'danger'" size="small" disable-transitions>{{row.is_active==1?'启用':'禁用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="type_code" label="编码" min-width="320"> </el-table-column>
      <el-table-column prop="name" label="综合类别名称" min-width="320"> </el-table-column>
      <el-table-column prop="abbreviation" label="综合类别缩写" min-width="200"> </el-table-column>
      <el-table-column prop="user_name" label="创建人" min-width="180"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间" min-width="180"> </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="150" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="misc_type_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="misc_type_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="添加综合类别" width="1000px">
      <l-misc-type-edit @on-success="onAddSucess" :visible.sync="add_visible"></l-misc-type-edit>
    </l-dialog>

    <!--编辑-->
    <l-dialog :visible.sync="edit_visible" title="编辑综合类别" width="1000px">
      <l-misc-type-edit @on-success="onEditSucess" :visible.sync="edit_visible" :id="edit_id"></l-misc-type-edit>
    </l-dialog>
  </el-card>
</template>

<script>
import Edit from "./Edit.vue";
import Vue from "vue";

export default {
  components: {
    [Edit.name]: Edit,

  },
  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      export_loading:false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      edit_visible: false, //是否显示编辑
      edit_id: 0,
      info_id: 0,

      //搜索
      search_visible: false,
      search_data: {
        name:"",
        abbreviation:""
      },
      rel_search_data: {},
      show_more_search: false,
    };
  },
  computed:{
  },

  mounted() {
    this.getList();
  },

  methods: {
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("miscType_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;

      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },

    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`miscType_del`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },
  },
};
</script>
